<script setup>
import {Link, usePage} from '@inertiajs/vue3';
import {infoContactUs, termAndCoditions} from '@/Stores/Data.js';
import {ref, onMounted, onUnmounted, computed, nextTick} from 'vue';
import Form from '@/Components/Form.vue';
import imageHelper from '@/Helpers/image_helper.js';


const { getImage } = imageHelper.methods;
const footer = computed(() => usePage().props.footer);
const contactInformation = computed(() => usePage().props.contactInformation);
const location = computed(() => usePage().props.location);
const socialMedia = computed(() => usePage().props.socialMedia);
const setting = computed(() => usePage().props.setting);

const props = defineProps({
    showContactUs: {
        type: Boolean,
        default: false
    },
});

const contactUsSetting = computed(() => {
    return setting.value.filter(item => item.key === 'contact_us');
});

const copyrightSetting = computed(() => {
    return setting.value.filter(item => item.key === 'copyright');
});

const informationSetting = computed(() => {
    return setting.value.filter(item => item.key === 'information');
});

const socialMediaSetting = computed(() => {
    return setting.value.filter(item => item.key === 'social_media');
});

const isMobile = ref(false);

const checkScreenSize = () => {
    isMobile.value = window.innerWidth < 1024;
};

onMounted(() => {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
});

onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
});

const descriptionContainers = ref([]);

onMounted(async () => {
    await nextTick();

    descriptionContainers.value.forEach((container) => {
        if (container) {
            const links = container.querySelectorAll('a');
            links.forEach((link) => {
                const href = link.getAttribute('href');

                if (href) {
                    if (href.startsWith('http')) {
                        link.setAttribute('target', '_blank');
                        link.setAttribute('rel', 'noopener noreferrer');
                    } else if (href.startsWith('mailto:') || href.startsWith('tel:')) {
                        link.removeAttribute('target');
                        link.removeAttribute('rel');
                    }
                }
            });
        }
    });
});
</script>

<template>
    <template v-if="showContactUs">
        <div class="bg-cover bg-center py-5 md:py-10 content-padding"
             style="background-image: url('/assets/988tech/img/footer/banners/banner-14.png');">

            <div class="content-body">
                <template v-for="item in contactUsSetting">
                    <h1 class="text-secondary md:text-quaternary font-bold leading-8 text-center mb-5 md:mb-10">
                        {{ item.value }}
                    </h1>
                </template>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-x-5">
                    <!--== Form Request ==-->
                    <Form />

                    <div class="w-full h-full flex flex-col justify-center items-start gap-y-3 md:gap-y-10 pt-5 md:pt-0 px-5 md:px-0">
                        <template v-for="(item, index) in footer" :key="index">
                            <div class="flex justify-start items-center gap-x-2">
                                <img class="h-8 md:h-10" :src="getImage(item.image_thumbnail)" alt="Icon Contact us">

                                <div class="flex flex-col justify-start gap-y-0">
                                    <h2 class="text-primary md:text-tertiary font-bold">{{ item.title }}</h2>
                                    <p class="text-description">{{ item.description }}</p>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <footer class="w-full bg-colorBgFooter text-white">
        <div
            class="content-body flex flex-wrap justify-between items-start gap-y-3 md:gap-y-0 py-5 md:py-10 content-padding">
            <!--== Contact us ==-->
            <div class="flex flex-col justify-start items-start gap-y-2 order-3 md:order-1">
                <template v-for="item in informationSetting">
                    <h1 class="text-primary md:text-secondary font-bold mb-1 md:mb-4">{{ item.value }}</h1>
                </template>
                <div class="flex justify-center items-center gap-x-5">
                    <template v-for="(item, index) in contactInformation" :key="index">
                        <div class="flex justify-center items-center gap-x-2 hover:text-primaryColor">
                            <img class="h-5" :src="getImage(item.image_thumbnail)" alt="">
                            <a class="text-14 font-medium" v-html="item.description" ref="descriptionContainers"></a>
                        </div>

                        <template v-if="index < infoContactUs.length - 1">
                            <hr class="border border-colorBorderFooter h-5">
                        </template>
                    </template>
                </div>

                <template v-for="(item, index) in location" :key="index">
                    <div class="flex justify-start items-start gap-x-2">
                        <img class="h-5" :src="getImage(item.image_thumbnail)" alt="">
                        <a class="text-14 font-medium hover:text-primaryColor" v-html="item.description"
                           ref="descriptionContainers"></a>
                    </div>
                </template>
            </div>

            <!--== Social media ==-->
            <div class="flex flex-col justify-start md:justify-center items-start md:items-center order-2">
                <template v-for="item in socialMediaSetting">
                    <h1 class="text-primary md:text-secondary font-bold mb-4">{{item.value}}</h1>
                </template>
                <div class="flex gap-x-2 md:gap-x-3">
                    <template v-for="(item, index) in socialMedia">
                        <a :href="item.description" target="_blank" class="mt-1.5 md:mt-2.5">
                            <img class="h-5 transition-transform transform hover:scale-110" :src="getImage(item.image_thumbnail)" alt="">
                            <!--                            <i :class="`${item.icon} text-[20px] md:text-[24px] hover:text-primaryColor`"></i>-->
                        </a>
                    </template>
                </div>
            </div>

            <!--== Logo term and conditon ==-->
            <div class="flex flex-col justify-end order-1 md:order-3">
                <div class="mb-2 md:mb-3 flex justify-start md:justify-end">
                    <img class="h-9 md:h-10" src="/assets/988tech/logo/988tech-footer.png" alt="988tech logo">
                </div>

                <div class="flex justify-center items-center gap-x-5">
                    <template v-for="(item, index) in termAndCoditions" :key="index">
                        <div class="flex justify-end items-end">
                            <Link :href="route(item.routeName)" class="text-14 font-medium hover:text-primaryColor">
                                {{ item.title }}
                            </Link>
                        </div>

                        <template v-if="index < termAndCoditions.length - 1">
                            <hr class="border border-colorBorderFooter h-5">
                        </template>
                    </template>
                </div>
            </div>
        </div>
        <template v-for="item in copyrightSetting">
            <p class="text-14 text-colorBorderFooter text-center py-3 border-t border-colorBorderFooterCopyright">
                {{ item.value }}
            </p>
        </template>
    </footer>
</template>
